var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 318.2",
    style: {
      enableBackground: "new 0 0 512 318.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFCB05;}\n\t.st2{fill:#00A4E0;}\n\t.st3{fill:#EF4123;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4,
    className: "st0",
    width: 512,
    height: 318.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,117.1c4.4-1.5,9.1-2.3,14-2.3c21.4,0,39.3,15.2,43.4,35.4l30.4-6.2c-7-34.3-37.3-60.2-73.8-60.2 c-8.4,0-16.3,1.4-23.9,3.9L120.9,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85,215.5l20.5-23.2c-9.2-8.1-14.9-20-14.9-33.2s5.8-25,14.9-33.1L85,102.7c-15.6,13.8-25.4,33.9-25.4,56.4 C59.6,181.5,69.5,201.7,85,215.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.3,168c-4.1,20.2-22,35.4-43.4,35.4c-4.9,0-9.6-0.8-14.1-2.3l-9.8,29.4c7.5,2.5,15.5,3.9,23.9,3.9 c36.4,0,66.7-25.8,73.7-60.1L178.3,168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,193.2c-1-1.6-2.3-4.2-3.2-6.1c-4.8-11.2-5-22.7-1-33.8c4.5-12.2,13-21.5,24-26.2c13.9-6,29.2-4.8,42.4,3.1 c8.4,4.8,14.4,12.3,18.9,22.9c0.6,1.4,1.1,2.8,1.6,4L235.2,193.2z M262.9,145.1c-9.8,4.2-14.9,13.5-13.9,24.3l41.7-17.9 C283.5,143,274.2,140.2,262.9,145.1L262.9,145.1z M295.9,184.1C295.8,184.1,295.8,184.1,295.9,184.1l-0.9-0.6 c-2.5,4-6.4,7.3-11.3,9.4c-9.3,4-17.9,3-24.2-2.4l-0.6,0.9l0,0l-10.6,15.8c2.6,1.8,5.4,3.4,8.4,4.6c11.7,4.9,23.6,4.6,35.4-0.5 c8.5-3.7,15.2-9.3,19.7-16.4L295.9,184.1z M347,103.9v87.9l13.7,5.5l-7.8,18.1l-15.1-6.3c-3.4-1.5-5.7-3.7-7.4-6.2 c-1.7-2.6-2.9-6.1-2.9-10.9v-88.2L347,103.9z M382.4,169.4c0-7.5,3.3-14.2,8.5-18.8l-14-15.6c-9.5,8.4-15.5,20.7-15.5,34.4 c0,13.7,6,26,15.5,34.4l14-15.6C385.7,183.5,382.4,176.9,382.4,169.4L382.4,169.4z M407.3,194.3c-2.8,0-5.4-0.5-7.9-1.3l-6.7,19.9 c4.6,1.5,9.5,2.4,14.6,2.4c22.2,0,40.7-15.7,45-36.7l-20.6-4.2C429.4,185.8,419.4,194.3,407.3,194.3L407.3,194.3z M407.4,123.5 c-5.1,0-10,0.8-14.6,2.3l6.6,19.9c2.5-0.8,5.1-1.3,7.9-1.3c12.1,0,22.1,8.6,24.4,20l20.6-4.2C448.1,139.3,429.6,123.5,407.4,123.5 L407.4,123.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElo);
export default __webpack_public_path__ + "static/media/elo.d89aee0fd37fc6cc41d3070d5696cd46.svg";
export { ForwardRef as ReactComponent };